import React, { useState } from 'react';
import { ChangePasswordForm } from './ChangePasswordForm';
import { AuthAPI } from '../services/api';
import './ConfirmationDialog.css';

interface ChangePasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  onPasswordChanged?: () => void;
}

interface ChangePasswordData {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({
  isOpen,
  onClose,
  onPasswordChanged
}) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  if (!isOpen) return null;

  const handlePasswordChange = async (data: ChangePasswordData) => {
    setLoading(true);
    try {
      await AuthAPI.changePassword(data.currentPassword, data.newPassword);

      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
        onClose();
        onPasswordChanged?.();
      }, 2000);
    } catch (error: any) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

  return (
    <div className="confirmation-overlay" onClick={handleClose}>
      <div className="confirmation-dialog" onClick={(e) => e.stopPropagation()}>
        {success ? (
          <div className="confirmation-body">
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <div style={{ color: 'var(--success-color)', fontSize: '3rem', marginBottom: '1rem' }}>
                ✓
              </div>
              <h3>Password Changed Successfully!</h3>
              <p>Your password has been updated.</p>
            </div>
          </div>
        ) : (
          <div className="confirmation-body">
            <ChangePasswordForm
              onSubmit={handlePasswordChange}
              onCancel={handleClose}
              loading={loading}
            />
          </div>
        )}
        
        {!success && (
          <button
            onClick={handleClose}
            className="close-button"
            disabled={loading}
            style={{
              position: 'absolute',
              top: '1rem',
              right: '1rem',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '1.5rem',
              color: 'var(--text-secondary)',
              width: '32px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
            }}
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};